import React from 'react';
import { SEO } from '../components/SEO';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { Features } from '../components/Features';
import { Topics } from '../components/Topics';
import { Footer } from '../components/Footer';
import { Section } from '../components/ui/Section';
import { Button } from '../components/ui/Button';
export function Home() {
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-blue-100 selection:text-blue-900" data-id="element-158">
      <SEO title="Dataprixa | Data Infrastructure & Digital Security Insights" description="Dataprixa is an independent editorial platform delivering in-depth analysis on data infrastructure, web scraping, proxy architectures, and digital security." data-id="element-159" />

      <Header data-id="element-160" />

      <main data-id="element-161">
        <Hero data-id="element-162" />
        <Features data-id="element-163" />
        <Topics data-id="element-164" />

        {/* CTA Section */}
        <Section background="dark" className="text-center" data-id="element-165">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-166">
            Read Our Latest Articles
          </h2>
          <p className="text-xl text-slate-300 max-w-2xl mx-auto mb-10" data-id="element-167">
            Developers and researchers use{' '}
            <a href="https://dataprixa.com" className="text-blue-400 hover:underline font-medium" data-id="element-168">
              Dataprixa
            </a>{' '}
            to learn about data infrastructure and security. Join them and get
            practical knowledge you can use today.
          </p>
          <a href="https://dataprixa.com" data-id="element-169">
            <Button variant="secondary" className="px-8 py-4 text-lg" data-id="element-170">
              Visit Dataprixa.com
            </Button>
          </a>
        </Section>
      </main>

      <Footer data-id="element-171" />
    </div>;
}